const ExternalIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 16 17"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="m12 9.16667v4.00003c0 .3536-.1405.6927-.3905.9428-.2501.25-.5892.3905-.9428.3905h-7.33337c-.35362 0-.69276-.1405-.94281-.3905-.25004-.2501-.39052-.5892-.39052-.9428v-7.33337c0-.35362.14048-.69276.39052-.94281.25005-.25004.58919-.39052.94281-.39052h4" />
      <path d="m10 2.5h4v4" />
      <path d="m6.66699 9.83333 7.33331-7.33333" />
    </svg>
  );
};
export default ExternalIcon;
